var map = {
	"./404.svg": "sEM+",
	"./automation.svg": "sIVO",
	"./bangfudashuju.svg": "0D+i",
	"./baobiao.svg": "aJfs",
	"./baogao.svg": "gtgx",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./click.svg": "zYPD",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./computer.svg": "i/3Z",
	"./conversation.svg": "rce0",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./guide.svg": "z74U",
	"./icon-jifei.svg": "0dJ2",
	"./icon.svg": "vUvT",
	"./iconbianzubeifen10.svg": "JKdV",
	"./iconbianzubeifen12.svg": "JzEp",
	"./iconbianzubeifen7.svg": "0ZXa",
	"./iconbianzubeifen8.svg": "W8GW",
	"./iconchangwenbenhecheng.svg": "rUzT",
	"./iconchangyuyinhecheng.svg": "ho7j",
	"./iconduihuakuang.svg": "+uNa",
	"./iconshengyinfuke.svg": "zifV",
	"./iconshengyinzhuanhuan.svg": "2o34",
	"./iconshouye1.svg": "w8fH",
	"./iconyijuhuashibie.svg": "TUZW",
	"./iconyuyinwenjianshibie.svg": "Mj/c",
	"./info.svg": "Yfis",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./qus.svg": "HqYH",
	"./search.svg": "Bx0U",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./skill.svg": "NpjO",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tree-table.svg": "myHh",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 1